export const convertLocalTimeKeyToUtc = (localTimeKey) => {
  const [h1,h2,m1,m2] = localTimeKey;
  const hours = `${h1}${h2}`;
  const mins = `${m1}${m2}`;
  const d = new Date();
  d.setHours(Number(hours));
  d.setMinutes(Number(mins));
  const utcHours = new Date(d).getUTCHours();
  const utcMins = new Date(d).getUTCMinutes();
  const paddedUTCHours = utcHours < 10 ? `0${new Date(d).getUTCHours()}` : `${new Date(d).getUTCHours()}`;
  const paddedUTCMins = utcMins < 10 ? `0${new Date(d).getUTCMinutes()}` : `${new Date(d).getUTCMinutes()}`;

  return `${paddedUTCHours}${paddedUTCMins}`;
}

export const convertUtcTimeKeyToLocal = (utcTimeKey) => {
  const [h1,h2,m1,m2] = utcTimeKey;
  const hours = `${h1}${h2}`;
  const mins = `${m1}${m2}`;
  const d = new Date();
  d.setUTCHours(Number(hours));
  d.setUTCMinutes(Number(mins));
  const localHours = new Date(d).getHours();
  const localMins = new Date(d).getMinutes();
  const paddedLocalHours = localHours < 10 ? `0${new Date(d).getHours()}` : `${new Date(d).getHours()}`;
  const paddedLocalMins = localMins < 10 ? `0${new Date(d).getMinutes()}` : `${new Date(d).getMinutes()}`;

  return `${paddedLocalHours}${paddedLocalMins}`;
}
